import React from 'react';
import { Link } from 'react-router-dom';
import { RiUser3Line } from '@remixicon/react';
import { cn } from '@/utils/helpers';

interface UserCellProps {
  user: {
    id?: number;
    user_id?: number;
    first_name: string;
    last_name: string;
    email: string;
  };
  showEmail?: boolean;
  dense?: boolean;
  linked?: boolean;
}

export function UserCell({ user, showEmail = true, dense = false, linked = false }: UserCellProps) {
  const names = [user.first_name, user.last_name].filter(Boolean).join(' ').trim();
  const fullName = names || '';
  const displayName = fullName || '- no name -';

  const content = (
    <div className="flex items-center gap-1">
      <div className="shrink-0">
        <RiUser3Line className={cn('text-default-400 shrink-0', dense ? 'size-4' : 'size-6')} />
      </div>
      <div className="flex min-w-0 flex-col">
        <span className={cn('truncate font-medium', dense && 'text-xs')}>{displayName}</span>
        {showEmail && (
          <span className={cn('text-default-500 truncate text-xs', dense ? 'line-clamp-1' : 'line-clamp-2')}>
            {user.email}
          </span>
        )}
      </div>
    </div>
  );

  if (linked) {
    return (
      <Link to={`/users?filter[email]=${encodeURIComponent(user.email)}`} className="block">
        {content}
      </Link>
    );
  }

  return content;
}
